export default "__VITE_ASSET__CZvYEJBC__"